export default __webpack_public_path__ + "images/5f770fd4c63cf4a04fd9807c87faa02e.svg";